// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-color: #16161a;
  --primary-color: #2cb67d;
  --red: #e53170;
  --purple: #7f5af0;
}

body {
  background-color: var(--background-color);
  color: white;
  height: 100vh;
  font-family: "Tiny5", sans-serif;
  font-size: 1.3rem;
}

#content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 2.5rem;
}

.hero-container {
  display: flex;
  align-items: center;
}

.hero-text {
  font-family: "Silkscreen", sans-serif;
  font-size: 2rem;
  cursor: default;
}

.hero-logo {
  width: 4rem;
  height: auto;
}

.game-message {
  color: var(--primary-color);
  border: 0.1rem solid var(--primary-color);
  border-radius: 0.2rem;
  width: 40rem;
  padding: 1rem;
  text-align: center;
}

.boards-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20rem;
}

.player-board-container,
.computer-board-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.gameboard {
  display: grid;
  grid-template-columns: repeat(10, 2.8rem);
  grid-template-rows: repeat(10, 2.8rem);
}

.coord {
  border: 0.1rem solid var(--primary-color);
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coord:nth-child(-n + 10) {
  border-top: none;
}

.coord:nth-last-child(-n + 10) {
  border-bottom: none;
}

.coord:nth-child(10n + 1) {
  border-left: none;
}

.coord:nth-child(10n) {
  border-right: none;
}

.empty-coord-hover:hover,
.ship-selected-hover {
  cursor: pointer;
  background-color: #25d68c;
}

.invalid-coord-hover {
  cursor: pointer;
  background-color: var(--red);
}

.player-ship-placement-module {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
}

.player-ship-placement-module-inactive {
  opacity: 0;
}

.player-ship-placement-module-inactive .player-ship,
.player-ship-placement-module-inactive .direction-btn {
  cursor: default;
}

.player-ships-container {
  display: flex;
  gap: 2rem;
}

.player-ship,
.direction-btn {
  cursor: pointer;
  height: 4rem;
  width: 8rem;
  border-width: 0.2rem 0.4rem 0.2rem 0.4rem;
  border-style: solid;
  border-color: var(--primary-color);
  border-radius: 0.2rem;
  background-color: var(--background-color);
  color: white;
  box-shadow: 0rem 1rem 0rem 0 var(--primary-color);
  transition: 0.2s ease-in-out;
}

.direction-btn {
  transition: 0.1s ease-out;
  border-color: var(--purple);
  box-shadow: 0rem 1rem 0rem 0 var(--purple);
}

.player-ship-focus {
  transform: translateY(1rem);
  box-shadow: 0rem 0rem 0rem 0 var(--primary-color);
}

.player-ship:disabled {
  transform: translateY(1rem);
  box-shadow: 0rem 0rem 0rem 0 var(--primary-color);
  border-color: var(--red);
}

.direction-btn:active {
  transform: translateY(1rem);
  box-shadow: 0rem 0rem 0rem 0 var(--primary-color);
}

.ship-icon,
.hit-icon,
.miss-icon,
.sunk-icon {
  width: 2rem;
  height: auto;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yCAAyC;EACzC,mBAAmB;EACnB,kCAAkC;EAClC,qBAAqB;EACrB,yCAAyC;EACzC,YAAY;EACZ,iDAAiD;EACjD,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB","sourcesContent":[":root {\n  --background-color: #16161a;\n  --primary-color: #2cb67d;\n  --red: #e53170;\n  --purple: #7f5af0;\n}\n\nbody {\n  background-color: var(--background-color);\n  color: white;\n  height: 100vh;\n  font-family: \"Tiny5\", sans-serif;\n  font-size: 1.3rem;\n}\n\n#content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  gap: 2.5rem;\n}\n\n.hero-container {\n  display: flex;\n  align-items: center;\n}\n\n.hero-text {\n  font-family: \"Silkscreen\", sans-serif;\n  font-size: 2rem;\n  cursor: default;\n}\n\n.hero-logo {\n  width: 4rem;\n  height: auto;\n}\n\n.game-message {\n  color: var(--primary-color);\n  border: 0.1rem solid var(--primary-color);\n  border-radius: 0.2rem;\n  width: 40rem;\n  padding: 1rem;\n  text-align: center;\n}\n\n.boards-container {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 20rem;\n}\n\n.player-board-container,\n.computer-board-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2rem;\n}\n\n.gameboard {\n  display: grid;\n  grid-template-columns: repeat(10, 2.8rem);\n  grid-template-rows: repeat(10, 2.8rem);\n}\n\n.coord {\n  border: 0.1rem solid var(--primary-color);\n  width: 2.8rem;\n  height: 2.8rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.coord:nth-child(-n + 10) {\n  border-top: none;\n}\n\n.coord:nth-last-child(-n + 10) {\n  border-bottom: none;\n}\n\n.coord:nth-child(10n + 1) {\n  border-left: none;\n}\n\n.coord:nth-child(10n) {\n  border-right: none;\n}\n\n.empty-coord-hover:hover,\n.ship-selected-hover {\n  cursor: pointer;\n  background-color: #25d68c;\n}\n\n.invalid-coord-hover {\n  cursor: pointer;\n  background-color: var(--red);\n}\n\n.player-ship-placement-module {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  align-items: center;\n}\n\n.player-ship-placement-module-inactive {\n  opacity: 0;\n}\n\n.player-ship-placement-module-inactive .player-ship,\n.player-ship-placement-module-inactive .direction-btn {\n  cursor: default;\n}\n\n.player-ships-container {\n  display: flex;\n  gap: 2rem;\n}\n\n.player-ship,\n.direction-btn {\n  cursor: pointer;\n  height: 4rem;\n  width: 8rem;\n  border-width: 0.2rem 0.4rem 0.2rem 0.4rem;\n  border-style: solid;\n  border-color: var(--primary-color);\n  border-radius: 0.2rem;\n  background-color: var(--background-color);\n  color: white;\n  box-shadow: 0rem 1rem 0rem 0 var(--primary-color);\n  transition: 0.2s ease-in-out;\n}\n\n.direction-btn {\n  transition: 0.1s ease-out;\n  border-color: var(--purple);\n  box-shadow: 0rem 1rem 0rem 0 var(--purple);\n}\n\n.player-ship-focus {\n  transform: translateY(1rem);\n  box-shadow: 0rem 0rem 0rem 0 var(--primary-color);\n}\n\n.player-ship:disabled {\n  transform: translateY(1rem);\n  box-shadow: 0rem 0rem 0rem 0 var(--primary-color);\n  border-color: var(--red);\n}\n\n.direction-btn:active {\n  transform: translateY(1rem);\n  box-shadow: 0rem 0rem 0rem 0 var(--primary-color);\n}\n\n.ship-icon,\n.hit-icon,\n.miss-icon,\n.sunk-icon {\n  width: 2rem;\n  height: auto;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
